
export interface StudioTag {
    stdtag_id?: number,
    stdtag_name?: string,
    stdtag_memo?: string,
    std_list?: number[]
}

export interface ObjectToStudioTagProps {
    stdtag_id?: number | string,
    stdtag_name?: string,
    stdtag_memo?: string,
    std_list?: string
}
export const ObjectToStudioTag = ({
    stdtag_id,
    stdtag_name,
    stdtag_memo,
    std_list
}: ObjectToStudioTagProps): StudioTag => {
    return {
        stdtag_id: typeof stdtag_id == 'string' ? parseInt(stdtag_id) : stdtag_id,
        stdtag_name: stdtag_name,
        stdtag_memo: stdtag_memo,
        std_list: std_list ? std_list.split(",").map(std_id => parseInt(std_id)) : undefined
    }
}